// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { LMFormatUtilService } from '@services/utils';

@Pipe({
  name: 'booleanAsText',
  standalone: false
})
export class LMBooleanAsTextPipe implements PipeTransform {

  constructor(private lmFormatUtilService: LMFormatUtilService) { }

  transform(triggerValue: boolean, value): string {
    return this.lmFormatUtilService.booleanToDisplay(value);
  }
}
